import React from 'react';

// React view component to render
import { controlledDrugReorder as ControlledDrugReorderView } from 'ui/views/widgets/controlledDrugReorder';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { ControlledDrugReorder } from 'ui/containers/ControlledDrugReorder';
 *
 * // render
 * <ControlledDrugReorder propName='propValue'/>
 */
export class ControlledDrugReorder extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.state= {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <ControlledDrugReorderView
                { ...this.props }
                { ...this.state }
            />
        );
    }
}

// set display name
ControlledDrugReorder.displayName = 'ControlledDrugReorder';

// set default props
ControlledDrugReorder.defaultProps = {};

// prop types
ControlledDrugReorder.propTypes = {};
